// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "lib/css/" + chunkId + "." + "a4386532" + ".chunk.css";
};